import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ClientResponse } from '../../store/types';

interface ClientState {
  selectedClient: ClientResponse | null;
}

const initialState: ClientState = {
  selectedClient: null,
};

const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    setSelectedClient(state, action: PayloadAction<ClientResponse>) {
      state.selectedClient = action.payload;
    },
    clearSelectedClient(state) {
      state.selectedClient = null;
    },
  },
});

export const { setSelectedClient, clearSelectedClient } = clientSlice.actions;
export default clientSlice.reducer;
